import type { ReactNode } from 'react'

interface MobileAppShellProps {
  header?: ReactNode
  main: ReactNode
  bottomNav: ReactNode
  detailModal?: ReactNode
}

export function MobileAppShell({ header, main, bottomNav, detailModal }: MobileAppShellProps) {
  return (
    <div className="h-dvh w-screen flex flex-col bg-bg-base text-text-base overflow-hidden"
         style={{ minHeight: '-webkit-fill-available' }}>
      {header && <div className="flex-shrink-0">{header}</div>}
      <main className="flex-1 overflow-hidden min-h-0">
        {main}
      </main>
      <div className="flex-shrink-0">{bottomNav}</div>
      {detailModal}
    </div>
  )
}
